import { Injectable } from '@angular/core';

import { SETTINGS_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/settings-routes-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BasicSettingsGuard extends BasicRedirectToNextTabGuard {
  protected prefix = `/${ROUTING_PATH.SETTINGS.INDEX}`;
  protected defaultNavigateUrl = `/${this.prefix}/${ROUTING_PATH.SETTINGS.USERS}`;
  abstract featureFlag: keyof Flags;
  protected routerPathsAndFeatureFlags = SETTINGS_ROUTES_FEATURE_FLAGS;
}
